module.exports = __webpack_public_path__ + "static/media/insect(32).8de661dd.PNG";